import React, { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
// import { AuthServices } from "../../services/AuthService";
import { AuthContext } from "../../Context/AuthContext";
import { Link, useHistory, useParams } from "react-router-dom";
import { ApiService } from "../../services/ApiService";
import { useAlert } from "react-alert";

export const reset_Password = () => {
  const { login } = useContext(AuthContext);
  const alert = useAlert();
  const history = useHistory();
  const params = useParams();
  const [token, settoken] = React.useState(null);

  React.useEffect(() => {
    settoken(params.token);
  }, [params]);

  return (
    <React.Fragment>
      <div className="login-reg-panel">
        <div className="login-white-panel">
          <div className="login-show">
            <center>
              <div className="logo-img">
                <a href="/">
                  <img
                    src="/img/Needle_logo.png"
                    width="191px"
                    alt="needlelogo"
                    height="42px"
                  />
                </a>
                <br></br>
                <small></small>
              </div>
            </center>
            <Formik
              initialValues={{ password: "", confirm_password: "" }}
              onSubmit={async (values, { setSubmitting }) => {
                values.token = token;
                console.log(values);
                ApiService.post("password/reset", values)
                  .then((res) => {
                    if (res.data.success === true) {
                      console.log("res", res);
                      alert.success("Password reset successully");
                      history.push("/login");
                    }
                  })
                  .catch((error) => {
                    setSubmitting(false);
                    if (values.password !== values.confirm_password) {
                      return alert.error(
                        "The confirm password and password must match"
                      );
                    }
                    alert.error(error.response.data.message);
                  });
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="form-group mt-5">
                    <Field
                      type="password"
                      name="password"
                      className="form-control mt-5"
                      placeholder="Enter New Password"
                    />

                    <ErrorMessage name="password" component="div" />
                  </div>

                  <div className="form-group mt-5">
                    <Field
                      type="password"
                      name="confirm_password"
                      className="form-control mt-5"
                      placeholder="Comfirm New Password"
                    />

                    <ErrorMessage name="confirm_password" component="div" />
                  </div>

                  <div className="text-center">
                    <Link to="/" className="text-dark">
                      Already have an account? Login
                    </Link>
                  </div>
                  <span className="clearfix"></span>

                  <div className="text-center mt-5">
                    <button
                      type="submit"
                      className="btn btn-block nt-button-color-default btn-sm"
                    >
                      Submit{" "}
                      {isSubmitting ? (
                        <span
                          id="login_spinner"
                          className="fa fa-spin fa-spinner"
                        ></span>
                      ) : null}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/auth/reset_password.js